(() => {
  const pending = new WeakSet();
  const load = img => {
    if (pending.has(img)) return;
    pending.add(img);
    const src = img.dataset.fullSrc;
    const full = new Image();
    full.onload = async () => {
      try { await full.decode(); } catch (_) {}
      if (img.dataset.fullSrc !== src) { pending.delete(img); load(img); return; }
      img.src = src;
      img.removeAttribute('data-mosaic');
    };
    full.onerror = () => { pending.delete(img); img.src = src; img.removeAttribute('data-mosaic'); };
    full.src = src;
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); }
  }), {rootMargin:'200px'});
  const scan = root => root.querySelectorAll('img[data-mosaic][data-full-src]').forEach(img => observer.observe(img));
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('change', event => {
    const gallery = event.target.closest('.seronine-pdp-flatlay-gallery');
    if (gallery) scan(gallery);
  });
})();
